import React, { useContext, useEffect, useState } from "react";
import { Grid, makeStyles, Paper, Typography } from "@material-ui/core";

import ScalingContext from "../../../../../context/scaling/ScalingContext";

export default function ScalingOverview() {
  const useStyles = makeStyles((theme) => ({
    paper: {
      padding: 0,
    },
    box: {
      // border: `1px solid ${theme.palette.divider}`,
      textAlign: "center",
      height: "100%",
      padding: "10px 0",
    },
    divider: {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
  }));
  const classes = useStyles();

  const { campaigns, campaigns_searched } = useContext(ScalingContext);

  const [testing, setTesting] = useState(0);
  const [optimizing, setOptimizing] = useState(0);
  const [scaling, setScaling] = useState(0);
  const [pending, setPending] = useState(0);
  const [complete, setComplete] = useState(0);

  useEffect(() => {
    let data = campaigns_searched ? campaigns_searched : campaigns;

    // Function: Calculate Totals By Scaling Status & Action Status
    if (data) {
      // Scaling Status
      const testing = data.filter(
        (campaign) => campaign.scaling_status === "TESTING"
      ).length;

      const optimizing = data.filter(
        (campaign) => campaign.scaling_status === "OPTIMIZING"
      ).length;

      const scaling = data.filter(
        (campaign) => campaign.scaling_status === "SCALING"
      ).length;

      // Action Status
      const pending = data.filter(
        (campaign) =>
          campaign.actions.filter((action) => action.status === "PENDING")
            .length
      ).length;

      const complete = data.filter(
        (campaign) =>
          campaign.actions.filter((action) => action.status === "COMPLETE")
            .length
      ).length;

      setTesting(testing);
      setOptimizing(optimizing);
      setScaling(scaling);
      setPending(pending);
      setComplete(complete);
    }
  }, [campaigns, campaigns_searched]);

  return (
    <Grid item xs={12}>
      <Paper elevation={4} className={classes.paper}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs={4} className={classes.box}>
            <Typography variant="overline" color="textSecondary">
              <strong> Testing </strong>{" "}
            </Typography>{" "}
            <Typography variant="h5"> {testing} </Typography>{" "}
          </Grid>
          <Grid item xs={4} className={classes.box}>
            <Typography variant="overline" color="textSecondary">
              <strong> Optimizing </strong>{" "}
            </Typography>{" "}
            <Typography variant="h5"> {optimizing} </Typography>{" "}
          </Grid>
          <Grid item xs={4} className={classes.box}>
            <Typography variant="overline" color="textSecondary">
              <strong> Scaling </strong>{" "}
            </Typography>{" "}
            <Typography variant="h5"> {scaling} </Typography>{" "}
          </Grid>{" "}
        </Grid>
        <Grid item className={classes.divider}>
          {" "}
        </Grid>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs={6} className={classes.box}>
            <Typography variant="overline" color="textSecondary">
              <strong> PENDING </strong>{" "}
            </Typography>{" "}
            <Typography variant="h5"> {pending} </Typography>{" "}
          </Grid>
          <Grid item xs={6} className={classes.box}>
            <Typography variant="overline" color="textSecondary">
              <strong> COMPLETE </strong>{" "}
            </Typography>{" "}
            <Typography variant="h5"> {complete} </Typography>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Paper>{" "}
    </Grid>
  );
}
